import React, { useEffect, useRef, useState } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { useSupplierModel } from "../supplierModel";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IVRMSupplierDetail } from "../supplierService";
import { getFormValidatorErrText } from "@/utils/utils"
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { debounce } from "lodash";
export const BaseSupplierDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        addFormVal,
        editFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertSupplier,
        editSupplier,
        getSupplierOne,
        setEditFormVal,
        setAddFormVal,
        setSelectedRowKeys
    } = useSupplierModel();
    
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav, addNav, closeNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    //编辑时， 没有缓存调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getSupplierOne(detailsInfo.id)
        }
    }, [detailsInfo])

    //清楚缓存
    useEffect(() => {
        return () => {
            !findNav("13-1-1") && updateAddFormVal(null);
            !findNav("13-1-2") && updateEditFormVal(null);
        }
    }, [selectedNavId])

    //关闭当前页
    const onClose = () => {
        let { parentInfo } = detailsInfo
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "13-1");
        }
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailsInfo.mode === "edit") {
                editSupplier({ ...res, id: detailsInfo.id } as IVRMSupplierDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertSupplier(res as IVRMSupplierDetail).then(res => {
                    if(res){
                        onClose();
                        setSelectedRowKeys([res])
                    }
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "供应商编码",
                fieldLabel: Locale["Supplier Code"],
                fieldName: "code",
                disable: true,
                placeholder: "自动生成"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "供应商名称",
                fieldLabel: Locale["Supplier Name"],
                fieldName: "name",
                // rules: [{ required: true, message: "请输入供应商名称" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone",
            }, {
                type: FormItemTypeEnum.TreeSelect,
                // fieldLabel: "供应商类型",
                fieldLabel: Locale["Supplier Type"],
                fieldName: "typeCode",
                treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE),
                // rules: [{ required: true, message: "请选择供应商类型" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]

            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "电子邮箱",
                fieldLabel: Locale["Email"],
                fieldName: "email"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "办公电话",
                fieldLabel: Locale["Office Tel"],
                fieldName: "tel"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系地址",
                fieldLabel: Locale["Address"],
                fieldName: "address",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "登记日期",
                fieldLabel: Locale["Record Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "邮编",
                fieldLabel: Locale["Postcode"],
                fieldName: "postCode",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "状态",
                fieldLabel: Locale["Status"],
                fieldName: "enable",
            }
        ]
    };
    const makeFormItem: IYhFormItemsBox = {
        // title: "开票信息",
        title: Locale["Billing information"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "发票抬头",
                fieldLabel: Locale["Invoice title"],
                fieldName: "invoiceTitle",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "营业执照",
                fieldLabel: Locale["Business license"],
                fieldName: "licenseNo",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "开户银行",
                fieldLabel: Locale["Bank"],
                fieldName: "bank",
                // options:getSelectedDictOne(DictCodeEnmu.OPENBANK_TYPE)
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "银行账号",
                fieldLabel: Locale["Bank Account"],
                fieldName: "bankAcct",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "邮寄地址",
                fieldLabel: Locale["Mailing Address"],
                fieldName: "postAddress",
                span: 12,
                labelCol: { span: 3 }
            }
        ]
    }
    const otherFormItem: IYhFormItemsBox = {
        // title: "其它信息",
        title: Locale["Other Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建人",
                fieldLabel: Locale["Founder"],
                fieldName: "createUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "创建时间",
                fieldLabel: Locale["Founder Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改人",
                fieldLabel: Locale["Updater"],
                fieldName: "updateUser",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "修改时间",
                fieldLabel: Locale["Update Time"],
                fieldName: "updateTime",
                disable: true
            }
        ]
    }


    const onChange = (changedValues: { [key: string]: any }) => {
        // console.log(changedValues);
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem, makeFormItem, otherFormItem]
    }
    const reset = () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getSupplierOne(detailsInfo.id)
        }
        // message.success("重置成功")
        message.success(Locale['Successfully refreshed'])
        
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={debounce(() => { onSubmit() }, 900)}
            // onClick={onSubmit}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => reset()}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >{Locale["Back"]}</Button>
    </>;

    return (
        <>
            <YhPageHeader title={Locale["Supplier Management"]} />
            <YhBox title={`${detailsInfo.mode === "edit" ? Locale["Edit"] : Locale["Add"]}    ${Locale["Supplier"]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}